import { Bus } from "lucide-react";
import { fmtSession } from "@/lib/dates";

const WHO = ["Myself", "Children", "Myself and children"];
const input = "w-full rounded-xl border border-sand/20 bg-transparent p-3 text-sm text-sand placeholder:text-sand/60 focus:border-ochre focus:outline-none";

export const TransportFields = ({ value, onChange, sessions = [] }) => {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <div data-testid="transport-fields" className="mt-6 rounded-2xl border border-sand/20 p-4">
      <label className="flex cursor-pointer items-center gap-3 text-sm font-semibold">
        <input
          type="checkbox"
          data-testid="need-lift-checkbox"
          checked={value.needs_transport}
          onChange={(e) => set("needs_transport", e.target.checked)}
          className="h-5 w-5 accent-[#C2502A]"
        />
        <Bus className="h-4 w-4 text-ochre" /> Need a lift?
      </label>
      <p className="mt-1 pl-8 text-xs text-sand/75">For Elders, seniors and children — our team will arrange transport to sessions.</p>
      {value.needs_transport && (
        <div className="mt-4 space-y-3">
          <div className="flex flex-wrap gap-2">
            {WHO.map((w) => (
              <button
                type="button"
                key={w}
                data-testid={`transport-for-${w.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => set("transport_for", w)}
                className={`rounded-full border px-3 py-1.5 text-xs transition-colors ${value.transport_for === w ? "border-ochre bg-ochre text-sand" : "border-sand/30 hover:border-sand"}`}
              >
                {w}
              </button>
            ))}
          </div>
          <input data-testid="pickup-suburb-input" value={value.pickup_suburb} onChange={(e) => set("pickup_suburb", e.target.value)} placeholder="Pick-up suburb" className={input} />
          {sessions.length > 0 && (
            <select data-testid="transport-session-select" value={value.session_id} onChange={(e) => set("session_id", e.target.value)} className={`${input} bg-ink`}>
              <option value="">Which session? (optional)</option>
              {sessions.map((s) => <option key={s.id} value={s.id}>{fmtSession(s)}{s.location ? ` · ${s.location}` : ""}</option>)}
            </select>
          )}
          <input data-testid="transport-notes-input" value={value.transport_notes} onChange={(e) => set("transport_notes", e.target.value)} placeholder="Number of children, car seats, mobility needs (optional)" className={input} />
        </div>
      )}
    </div>
  );
};
